angular.module('natgeo').controller('Level5TestScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'UserProgress', 'CommonFunctions', 'SoundEngine',
function Level5TestScreen($scope, element, ScreenFactory, manager, container, UserProgress, CommonFunctions, SoundEngine)
{
	var screen = ScreenFactory( 'level5_test', element );
	
	// Initialize the drag-and-drop command interface.
	CommonFunctions.initializeCommandInterface( screen, container, false, UserProgress, SoundEngine );
	
	// Don't allow them to play if it's already playing OR they completed it
	$scope.playing = false;
	$scope.tries = 0;

	// Everytime the screen is first entered...
	screen.on('introBefore', function()
	{
		// Update Complete Darkness visibility
		if ( !$scope.$$phase )
		{
			$scope.$apply();
		}

		// Hide the failure screens again.
		screen._failReflector.addClass( 'hidden' );
		screen._failBroom.addClass( 'hidden' );
	});

	// If the robot has the reflector equipped, show the failure screen
	screen.on('introEnd', function()
	{
		if ( $scope.hasReflector() )
		{
			setTimeout(function()
			{
				CommonFunctions.showHelp( screen._failReflector );

			}, 3000);
		}
	});

	// Triggered when the user hits enter
	screen.onEnter = function()
	{
		$scope.play();
	};
	
	// Triggered when they successfully reach the target
	screen.onTargetReached = function()
	{
		screen._robotLight
			.play( 'flash x2' )
			.animators()
			.once( 'finished', function()
			{
				// Show that success screen, show it real good
				CommonFunctions.showHelp( screen.getSuccess() )
			})
		;

		SoundEngine.play( 'goal-achieved' );
	};
	
	// Triggered when they failed to reach the target
	screen.onTargetMissed = function()
	{	
		// Show that failure screen.
		CommonFunctions.showHelp( screen.getFail() );

		SoundEngine.play( 'fail-bump' );
	};

	// Returns the current fail screen
	screen.getFail = function()
	{
		return screen.sprite( 'fail' + (screen.currentWave + 1) );
	};

	// Returns the current success screen
	screen.getSuccess = function()
	{
		return screen.sprite( 'success' + (screen.currentWave + 1) );
	};

	// Rebuild your robot!
	$scope.rebuild = function()
	{
		manager.transition( 'level5_build' );
	};

	// Try again!
	$scope.tryAgain = function()
	{
		// Hide the fail screen
		CommonFunctions.hideHelp( screen.getFail(), screen.tryAgainProcess );
	};
	
	// If the user has the reflector equipped.
	$scope.hasReflector = function()
	{
		return UserProgress.ExplorerLight === UserProgress.ExplorerLights.Reflector;
	};

	// Proceed with the retry once the failure screen is gone.
	screen.tryAgainProcess = function()
	{
		// Hide the robot, set everything up again.
		screen._robot
			.animators()
			.play('fadeOut', {delay:1000} )
			.once('finished', function() {
				screen.resetDarkness();
				screen.resetCauseway();
				screen.setupRetry();
				screen.setupRetryRobot();
				screen._robot.play('fadeIn');
			})
		;

		// Show that go again
		screen.outroduce('dontgo', 'fadeOut');
		screen.introduce('go', 'fadeIn');
	};

	// Continue Playing!
	$scope.nextWave = function()
	{
		// Hide the success screen always
		CommonFunctions.hideHelp( screen.getSuccess(), screen.nextWaveProceed );
	};

	// Proceed with the next wave once the success screen is gone.
	screen.nextWaveProceed = function()
	{
		// Last wave?
		if ( screen.currentWave + 1 === screen.waves.length )
		{
			$scope.next();
		}
		else
		{
			// Hide Current Description
			screen.outroduce( 'description' + screen.currentWave, 'flipOutX' );

			// Destroy the commands!
			screen.destroyCommands();

			// Next Wave
			screen.currentWave++;

			// Transition Robot
			screen.resetDarkness();
			screen.resetCauseway();
			screen.setupWave();
			screen.reorientRobot();

			// GO!
			screen.outroduce('dontgo', 'fadeOut');
			screen.introduce('go', 'fadeIn');

			// Next Description
			screen.introduce( 'description' + screen.currentWave, 'flipInX ~1s' );
		}
	};

	// Reset the robot to the last position for the current wave
	screen.setupRetryRobot = function()
	{
    screen._robot
      .setAttributes({
        rotate: screen.lastRotation,
        translateX: screen.lastTranslateX,
        translateY: screen.lastTranslateY
      })
    ;
	};

	// Moves the darkness back to the initial value
	screen.resetDarkness = function()
	{
		var anim8or = screen._darkness.animators()[0];
		var start = anim8.coalesce( anim8or.frame.translateX, 0 );
		var end = screen.lastTranslateX;

		anim8or.play({
			keyframe: {
				from: {
					translateX: start
				},
				to: {
					translateX: end
				}
			}
		});
	};

	// Focus back to the last column
	screen.resetCauseway = function()
	{
		var anim8or = screen._causeway.animators()[0];
		var start = anim8.coalesce( anim8or.frame.translateX, 0 );
		var end = -screen.lastTranslateX;

		anim8or.play({
			keyframe: {
				from: {
					translateX: start
				},
				to: {
					translateX: end
				}
			}
		});
	};

	// Re-orient the robot
	screen.reorientRobot = function()
	{
		var turns = Math.floor(Math.abs( screen.lastRotation - 90 ) / 90);

		screen._robot
			.animators()
			.play({
				keyframe: {
					start: {
						rotate: screen.lastRotation
					},
					end: {
						rotate: 90
					}
				}
			}, {
				duration: turns * 1000
			})
			.once('finished', function()
			{
				screen.lastRotation = 90;
				screen.lastDirX = 1;
				screen.lastDirY = 0;
			})
		;
	};

	// All waves for this level.
	screen.waves = [
		// Wave 1
		[
			{
				start: {
					column: 0,
					row: 1,
					rotation: 90,
					dirX: 1,
					dirY: 0
				},
				target: {
					column: 5,
					row: 0,
					template: 'target1'
				},
				obstacles: [
					{
						column: 4,
						row: 0,
						mask: [[1]],
						template: 'obstacle3'
					},
					{
						column: 1,
						row: 1,
						mask: [[0, 1], [1, 1]],
						template: 'obstacle2'
					},
					{
						column: 6,
						row: 2,
						mask: [[1]],
						template: 'obstacle4'
					}
				]
			},
			{
				start: {
					column: 0,
					row: 1,
					rotation: 90,
					dirX: 1,
					dirY: 0
				},
				target: {
					column: 6,
					row: 0,
					template: 'target1'
				},
				obstacles: [
					{
						column: 1,
						row: 0,
						mask: [[1, 1, 1, 1, 1], [0, 1, 1, 1, 0]],
						template: 'obstacle1'
					},
					{
						column: 6,
						row: 2,
						mask: [[1]],
						template: 'obstacle3'
					}
				]
			},
			{
				start: {
					column: 0,
					row: 1,
					rotation: 90,
					dirX: 1,
					dirY: 0
				},
				target: {
					column: 5,
					row: 0,
					template: 'target1'
				},
				obstacles: [
					{
						column: 1,
						row: 1,
						mask: [[1]],
						template: 'obstacle3',
						rotate: 270
					},
					{
						column: 3,
						row: 0,
						mask: [[1, 1], [1, 0]],
						template: 'obstacle2',
						rotate: 180
					},
					{
						column: 5,
						row: 2,
						mask: [[1]],
						template: 'obstacle4'
					}
				]
			}
		],
		// Wave 2
		[
			{
				keepObstacles: true,
				target: {
					column: 12,
					row: 0,
					template: 'target2'
				},
				obstacles: [
					{
						column: 7,
						row: 1,
						mask: [[1, 0], [1, 1]],
						template: 'obstacle2',
						rotate: 90
					},
					{
						column: 9,
						row: 0,
						mask: [[1]],
						template: 'obstacle4',
						rotate: 90
					},
					{
						column: 10,
						row: 1,
						mask: [[0, 1], [1, 1]],
						template: 'obstacle2'
					}
				]
			},
			{
				keepObstacles: true,
				target: {
					column: 11,
					row: 1,
					template: 'target2'
				},
				obstacles: [
					{
						column: 7,
						row: 1,
						mask: [[1]],
						template: 'obstacle4',
						rotate: 90
					},
					{
						column: 9,
						row: 0,
						mask: [[1, 1], [1, 0]],
						template: 'obstacle2',
						rotate: 180
					},
					{
						column: 11,
						row: 2,
						mask: [[1]],
						template: 'obstacle3',
						rotate: 135
					}
				]
			},
			{
				keepObstacles: true,
				target: {
					column: 12,
					row: 0,
					template: 'target2'
				},
				obstacles: [
					{
						column: 8,
						row: 1,
						mask: [[0, 1, 1, 1, 0], [1, 1, 1, 1, 1]],
						template: 'obstacle1',
						rotate: 180
					},
					{
						column: 7,
						row: 0,
						mask: [[1]],
						template: 'obstacle3',
						rotate: 180
					}
				]
			}
		],
		// Wave 3
		[
			{
				keepObstacles: true,
				target: {
					column: 17,
					row: 1,
					template: 'target3'
				},
				obstacles: [
					{
						column: 13,
						row: 0,
						mask: [[1, 1, 1, 1, 1], [0, 1, 1, 1, 0]],
						template: 'obstacle1'
					},
					{
						column: 18,
						row: 1,
						mask: [[0, 1], [1, 1]],
						template: 'obstacle2'
					}
				]
			},
			{
				keepObstacles: true,
				target: {
					column: 17,
					row: 0,
					template: 'target3'
				},
				obstacles: [
					{
						column: 13,
						row: 2,
						mask: [[1]],
						template: 'obstacle3'
					},
					{
						column: 14,
						row: 0,
						mask: [[1]],
						template: 'obstacle3',
						rotate: 90
					},
					{
						column: 15, 
						row: 1,
						mask: [[1]],
						template: 'obstacle4',
						rotate: 90
					},
					{
						column: 16,
						row: 1,
						mask: [[1]],
						template: 'obstacle3',
						rotate: 180
					},
					{
						column: 18,
						row: 1,
						mask: [[1, 0], [1, 1]],
						template: 'obstacle2',
						rotate: 90
					}
				]
			},
			{
				keepObstacles: true,
				target: {
					column: 17,
					row: 2,
					template: 'target3'
				},
				obstacles: [
					{
						column: 13,
						row: 1,
						mask: [[0, 1], [1, 1]],
						template: 'obstacle2'
					},
					{
						column: 16,
						row: 1,
						mask: [[1]],
						template: 'obstacle3'
					},
					{
						column: 16,
						row: 0,
						mask: [[1]],
						template: 'obstacle4',
						rotate: 180
					},
					{
						column: 18,
						row: 0,
						mask: [[1, 1], [0, 1]],
						template: 'obstacle2',
						rotate: 270
					}
				]
			}
		]
	];

	// The map!
	screen.map = [
		[ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
		[ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
		[ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ]
	];

	// The size of an unscaled grid cell
	screen.gridSize = 87.4;

	// The location of the grid's top left in unscaled pixels
	screen.gridCorner = {
		x: 0,
		y: 0
	};

	// Command measurements for adding highlights
	screen.commandWidth = 66;
	screen.commandSeparation = 70;

	// The last state of the robot
	screen.lastColumn = 0;
	screen.lastRow = 0;
	screen.lastRotation = 0;
	screen.lastDirX = 0;
	screen.lastDirY = 0;
	screen.lastTranslateX = 0;
	screen.lastTranslateY = 0;
	
	// Displays the help modal with the given name
	$scope.help = CommonFunctions.help( screen );

	// Clear the commands!
	$scope.clearCommands = screen.destroyCommands;

	// Plays the commands!
	$scope.play = function()
	{
		if ( $scope.playing === true ) 
		{
			return;
		}

		$scope.playing = true;

		screen.outroduce('go', 'fadeOut');
		screen.introduce('dontgo', 'fadeIn');
		
		// The current wave
		var wave = screen.waves[ screen.currentWave ][ screen.currentWaveVariation ];	

		// The map (1 = obstacle, 2 = star, 0 = open)
		var map = anim8.copy( screen.map );

		// Add obstacles to map
		for (var i = 0; i < wave.obstacles.length; i++)
		{
			var obs = wave.obstacles[ i ];
			var mask = obs.mask;

			for (var y = 0; y < mask.length; y++)
			{
				for (var x = 0; x < mask[ y ].length; x++)
				{
					map[ y + obs.row ][ x + obs.column ] = mask[ y ][ x ];
				}
			}
		}

		// Add target last!
		map[ wave.target.row ][ wave.target.column ] = 2;
		
		// Determines whether the cell at the given column & row is traversible.
		var traversable = function(c, r) {
			return r >= 0 && r < map.length && c >= 0 && c < map[r].length && map[r][c] !== 1;
		};
		
		// The starting position of the robot
		if ( wave.start )
		{
			screen.lastColumn = wave.start.column;
			screen.lastRow = wave.start.row;
			screen.lastRotation = wave.start.rotation;
			screen.lastDirX = wave.start.dirX;
			screen.lastDirY = wave.start.dirY;
			screen.lastTranslateX = 0;
			screen.lastTranslateY = 0;
		}

		var column = screen.lastColumn;
		var row = screen.lastRow;

		// How many milliseconds it takes to execute a command.
		var commandExecutionTime = 1000;
		
		// The size of a grid cell in pixel
		var gridSize = screen.gridSize * container.getScale();
		
		// The initial orientation
		var rotation = screen.lastRotation;
		var translateX = screen.lastTranslateX;
		var translateY = screen.lastTranslateY;
		
		// The vector for which direction we're facing
		var dirX = screen.lastDirX;
		var dirY = screen.lastDirY;
		
		// Number of commands to execute
		var commandCount = screen.commands.count();
		
		// The animation frames.
		var keyframes = {};
		keyframes[ '0' ] = {
				rotate: rotation,
				translateX: translateX,
				translateY: translateY,
				easing: 'linear'
		};

		// Frames for The Darkness
		var darknessFrames = {};
		darknessFrames[ '0' ] = {
			translateX: screen.lastTranslateX
		};
		var darknessTranslate = screen.lastTranslateX;

		// The current time of the animation in milliseconds (offset a little)
		var currentTime = 0;

		// Reset accumulated highlighting delays
		screen.initHighlight( screen._leftHighlight );
		screen.initHighlight( screen._rightHighlight );
		screen.initHighlight( screen._forwardHighlight );
		
		// Generate the remaining frames based on the user's commands
		for (var i = 0; i < commandCount; i++)
		{
			var command = screen.commands[i];
			var type = command.template.data('command');
			var frame = ((i + 1) * 100 / commandCount).toString();
			
			// Highlight the current command
			screen.addHighlight( command, i, currentTime, commandExecutionTime );

			switch (type) 
			{
			case 'forward':
				var nextColumn = column + dirX;
				var nextRow = row + dirY;
				
				// Can we move forward?
				if ( traversable( nextColumn, nextRow ) ) 
				{
					// Only place a path marker behind us when we move (offset by half of execution time)
					screen.placePathMarker( column, row, currentTime + commandExecutionTime / 2 );

					// Go forward!
					translateX += dirX * gridSize;
					translateY += dirY * gridSize;
					row = nextRow;
					column = nextColumn;	

					// Move Darkness
					darknessTranslate += dirX * gridSize;
				}
				else
				{
					// Bump animation (3 times)
					for (var k = 0; k < 6; k++) 
					{
						var kframe = ((i * 6 + k) * 100 / (commandCount * 6)).toString();
						var koffset = ((k % 2) * 2 - 1);
						
						keyframes[ kframe ] = {
							rotate: rotation,
							translateX: translateX + koffset * dirX * gridSize * 0.05,
							translateY: translateY + koffset * dirY * gridSize * 0.05,
							easing: 'ease'
						};
					}
				}
				break;
				
			case 'right':
				// Rotate to the right and adjust our direction!
				rotation += 90;
				var t = dirX;
				dirX = -dirY;
				dirY = t;
				break;
				
			case 'left':
				// Rotate to the left and adjust our direction!
				rotation -= 90;
				var t = dirX;
				dirX = dirY;
				dirY = -t;
				break;
			}
			
			// Add the next frame!
			keyframes[ frame ] = {
				rotate: rotation,
				translateX: translateX,
				translateY: translateY,
				easing: 'linear'
			};

			// Add the next darkness frame!
			darknessFrames[ frame ] = {
				translateX: darknessTranslate
			};

			// Progress time (for marker delays)
			currentTime += commandExecutionTime;
		}

		// Animation & Options
		var robotAnimation = {
			keyframe: keyframes
		};
		var darknessAnimation = {
			keyframe: darknessFrames
		};
		var robotOptions = {
			delay: commandExecutionTime / 4,
			duration: commandCount * commandExecutionTime
		};

		// Block all input!
		screen._blocker.removeClass('hidden');

		// Start the moving sounds
		SoundEngine.play( 'robot-move', {loop:-1, delay: commandExecutionTime / 4} );
		
		// Animate that robot!		
		screen._robot.animators()
			.play( robotAnimation, robotOptions )
			.once('finished', function() 
			{
				SoundEngine.stopAll();

				$scope.playing = false;

				// Unblock all input!
				screen._blocker.addClass('hidden');

				if ( map[row][column] === 2 )
				{
					if ( screen.currentWave === 0 && UserProgress.ExplorerRetrieval === UserProgress.ExplorerRetrievals.Broom )
					{
						CommonFunctions.showHelp( screen._failBroom );
					}
					else
					{
						// Save final state for next target.
						screen.lastColumn = column;
						screen.lastRow = row;
						screen.lastRotation = rotation;
						screen.lastDirX = dirX;
						screen.lastDirY = dirY;
						screen.lastTranslateX = translateX;
						screen.lastTranslateY = translateY;

						screen.onTargetReached();
					}
				}
				else
				{
					screen.onTargetMissed();
				}
			})
		;

		// Animate that darkness!
		screen._darkness.animators()
			.play( darknessAnimation, robotOptions )
		;
	};

	// The next screen is the learn screen
	$scope.next = function()
	{
		manager.transition('level5_reward');
	};
	
	// The previous screen is the office screen
	$scope.prev = function()
	{
		manager.transition('level5_build');
	};
	
}]);